
import { OrderViewModel } from "@/interfaces/OrderViewModel";
import router from "@/router";
import Vue from "vue";
import { mapMutations } from "vuex";
import swal from "sweetalert";
import store from "@/store";

export default Vue.extend({
  name: "support-order-history",
  props: {
    payload: Object,
  },
  data() {
    return {
      orders: null as OrderViewModel[] | null,
    };
  },
  created() {
    this.init();
  },
  watch: {
    ordersVM() {
      this.init();
    },
  },
  methods: {
    ...mapMutations({ SetLoading: "setLoading" }),
    async init() {
      this.SetLoading(true);
      const arVM = await store.dispatch("GetOrderHistory", { patientUserID: this.payload?.patientUserID, patientAffiliateID: this.payload?.patientAffiliateID, questionnaireTypeID: this.payload?.questionnaireTypeID, rxID: this.payload?.rxID });
      this.SetLoading(false);
      if (!arVM || !arVM.success) {
        swal("Error", "There was an error getting order history!", "error");
        return;
      }
      if (arVM.redirectRoute && arVM.redirectRoute.length > 0) {
        router.push(arVM.redirectRoute);
        return;
      }
      this.orders = arVM.data;
    },
  },
});
